import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Confirm from "@/pages/Confirm";
import Vacancies from "@/pages/Vacancies";
import EventLanding from "@/pages/EventLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminEventsList from "@/pages/AdminEventsList";
import AdminEventEditor from "@/pages/AdminEventEditor";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAccount from "@/pages/AdminAccount";
import AdminBackups from "@/pages/AdminBackups";
import AdminSignOn from "@/pages/AdminSignOn";
import AdminAwards from "@/pages/AdminAwards";
import SignOn from "@/pages/SignOn";
import CommanderBoard from "@/pages/CommanderBoard";
import AdminHelp from "@/pages/AdminHelp";
import SuperAdmin from "@/pages/SuperAdmin";

function ProtectedAdmin({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 text-sm text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/events/:slug" element={<EventLanding />} />
          <Route path="/events/:slug/register" element={<Register />} />
          <Route path="/events/:slug/vacancies" element={<Vacancies />} />
          <Route path="/confirm/:token" element={<Confirm />} />
          {/* Short-URL alias so SMS confirmation links stay compact and gateway-safe. */}
          <Route path="/l/:token" element={<Confirm />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdmin><AdminEventsList /></ProtectedAdmin>} />
          <Route path="/admin/events/new" element={<ProtectedAdmin><AdminEventEditor /></ProtectedAdmin>} />
          <Route path="/admin/events/:eventId/edit" element={<ProtectedAdmin><AdminEventEditor /></ProtectedAdmin>} />
          <Route path="/admin/events/:eventId" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
          <Route path="/admin/events/:eventId/awards" element={<ProtectedAdmin><AdminAwards /></ProtectedAdmin>} />
          <Route path="/admin/events/:eventId/sign-on" element={<ProtectedAdmin><AdminSignOn /></ProtectedAdmin>} />
          <Route path="/events/:slug/sign-on" element={<SignOn />} />
          <Route path="/commander/:token" element={<CommanderBoard />} />
          <Route path="/admin/backups" element={<ProtectedAdmin><AdminBackups /></ProtectedAdmin>} />
          <Route path="/admin/account" element={<ProtectedAdmin><AdminAccount /></ProtectedAdmin>} />
          <Route path="/admin/help" element={<ProtectedAdmin><AdminHelp /></ProtectedAdmin>} />
          <Route path="/super-admin" element={<ProtectedAdmin><SuperAdmin /></ProtectedAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
